import type { BreadcrumbClickedEvent } from './BreadcrumbClickedEvent';
import { breadcrumbClickedSchema } from './BreadcrumbClickedSchema';

export const breadcrumbClickedToEvent = ({
  ctaWording,
  ctaPosition,
  targetUrl,
  clickPosition,
}: {
  ctaWording: string;
  ctaPosition: number;
  targetUrl: string;
  clickPosition: string;
}): BreadcrumbClickedEvent => {
  const event: BreadcrumbClickedEvent = {
    schema: breadcrumbClickedSchema.ref,
    data: {
      cta_wording: ctaWording,
      cta_position: ctaPosition,
      target_url: targetUrl,
      click_position: clickPosition,
    },
  };

  return event;
};
